/** Provider-agnostic OAuth operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const OAUTH_ISSUES = {
  /**
   * `medium`, and never paging, for the reasons on its Google twin `GOOGLE_TOKEN_REFRESH_FAILED`:
   * a customer action the customer is already told about, which no operator can clear. Resolved
   * the same two ways.
   */
  OAUTH_TOKEN_REFRESH_FAILED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "OAuth refresh token is invalid or expired — user must re-authenticate",
    severity: "medium",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Connection needs reauthorization",
    userGuidance:
      "This integration's sign-in expired and couldn't be refreshed. Reconnect the account to restore access."
  }
} as const satisfies Record<string, IssueDefinition>;
